import React from 'react';
import { Container } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';
import messages from '../../../../../messages';
import { isHCoreLanding } from '../../../../../helpers/isHCoreLanding';

import fcmhLogo from '../../../../../theme/assets/images/FCMH-Logo-FORSCHUNGSCAMPUS-MITTELHESSEN-01-ffffff.svg';
import logoJLU from '../../../../../theme/assets/images/footer/JLU_Giessen-Logo.svg';
import logoMarburg from '../../../../../theme/assets/images/footer/UniMarburg.svg';
import logoTHM from '../../../../../theme/assets/images/footer/Technische_Hochschule_Mittelhessen.svg';
import fcmhRasterFooter from '../../../../../theme/assets/images/FCMH-Raster-Footer.svg';

const Footer = () => {
  const intl = useIntl();
  const { pathname } = useLocation();

  if (isHCoreLanding(pathname)) {
    return null;
  }

  return (
    <footer id="footer" className="fcmh-footer">
      <Container>
        <div className="fcmh-footer__top">
          <img src={fcmhLogo} alt="FCMH Logo" className="fcmh-footer__logo" />

          <div className="fcmh-footer__links">
            <div className="fcmh-footer__links--top">
              <a href="/de/impressum">
                {intl.formatMessage(messages.footerImprintLink)}
              </a>
              <a href="/de/datenschutz">
                {intl.formatMessage(messages.footerPrivacyLink)}
              </a>
            </div>

            <div className="fcmh-footer__links--bottom">
              <a href="/en" className="lang lang--en">
                EN
              </a>
              <a href="/de" className="lang lang--de">
                DE
              </a>
              <a
                href="/de/ueber-uns/organisationsstruktur/geschaeftsstelle"
                className="fcmh-footer__contact"
              >
                {intl.formatMessage(messages.footerContactLink)}
              </a>
            </div>
          </div>
        </div>

        <div className="fcmh-footer__logos">
          <img src={logoJLU} alt="JLU Gießen" className="fcmh-footer__partnerlogo" />
          <img src={logoMarburg} alt="Universität Marburg" className="fcmh-footer__partnerlogo" />
          <img src={logoTHM} alt="Technische Hochschule Mittelhessen" className="fcmh-footer__partnerlogo" />
        </div>

        <div className="fcmh-footer__raster">
          <img src={fcmhRasterFooter} alt="Raster Grafik Footer" />
        </div>

        <div className="fcmh-footer__bottom">
          <p className="left">
            {intl.formatMessage(messages.footerCopyright)}
          </p>
          <p className="right">
            {intl.formatMessage(messages.footerLicence)}
          </p>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
